import { StyledContainer } from "./styled";

const Container = ({ children }) => (
  <StyledContainer>{children}</StyledContainer>
);

export default Container;
